import { Branding } from "./components/Branding";
import { FeatureConfiguration } from "features";

export * from "./types";

export default function (config: FeatureConfiguration) {
    config.addRoutes(config.routes.locationRoutes, [<Branding key="branding" />]);
}
